import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Badge, Button, Form, Modal, Accordion, useAccordionButton } from 'react-bootstrap'
import competences from '../../components/competences.json'
import methodologies from '../../components/methodologies.json'
import technologies from "../../components/technologies.json"
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidate, getTitles, reportCandidate } from '../../actions/candidatesActions'
import DOMPurify from 'dompurify'
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import { getCourseSubjects } from '../../actions/miscellaneousActions'
import Swal from 'sweetalert2'
import { getCandidateHistoryBySelection } from '../../actions/choosesActions'

export default function CandidateProfile({candidateToShow, affinity = null, actions = {}, favourite = false, selection, selectedCandidate}) {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()

    const {candidate, candidateuser, titles, resultcandidate} = useSelector(state=>state.candidates)
    const {history, historyLoading} = useSelector(state=>state.chooses)
    const {subjects} = useSelector(state => state.miscellaneous)

    const [usedSubjects, setUsedSubjects] = useState([])

    const [showReportModal, setShowReportModal] = useState(false)

    const [candidateReport, setCandidateReport] = useState(null)
    const [additionalComments, setAdditionalComments] = useState('')
    const [selectedOptions, setSelectedOptions] = useState([]);

    const handleCheckChange = (event, option) => {
        setSelectedOptions((prevSelected) => {
            if (event.target.checked) {
                return [...prevSelected, option]
            } else {
                return prevSelected.filter((item) => item !== option)
            }
        })
    }

    useEffect(() => {
        if(candidateToShow && candidateToShow?.iduser){
            dispatch(getCandidate(candidateToShow?.iduser))
            dispatch(getTitles())
        }
    },[dispatch, candidateToShow])

    useEffect(() => {
        if (selection && candidateToShow?.iduser) {
            dispatch(getCandidateHistoryBySelection(selection?._id || selection, candidateToShow.iduser))
        }
    }, [candidateToShow?.iduser, selection])

    const [competencesSelected, setCompetencesSelected] = useState({
        initial: competences,
        selected: []
    })
    useEffect(() => {
        async function setCompetences() {
            if (candidate && candidate?.competences) {
                let userCompetencesUsed = []
                let userInitialCompetences = [...competences]

                for await (const competence of candidate.competences) {
                    if (competences.find(c => c.id === competence)) {
                        userCompetencesUsed.push(competences.find(c => c.id === competence))
                        userInitialCompetences.splice(userInitialCompetences.findIndex(c => c.id === competence), 1)
                    }
                }
                setCompetencesSelected({
                    initial: userInitialCompetences,
                    selected: userCompetencesUsed
                })
            }
        }
        setCompetences()
    }, [candidate])

    const [methodologiesSelected, setMethodologiesSelected] = useState({
        initial: methodologies,
        selected: []
    })
    useEffect( () => {
        async function setMehodologies(){
            if (candidate && candidate.methodologies) {
                let userMethodologiesUsed = []
                let userInitialMethodologies = [...methodologies]

                for await(const competence of candidate.methodologies) {
                    if (methodologies.find(c => c.id === competence)) {
                        userMethodologiesUsed.push(methodologies.find(c => c.id === competence))
                        userInitialMethodologies.splice(userInitialMethodologies.findIndex(c => c.id === competence), 1)
                    }
                }

                setMethodologiesSelected({
                    initial: userInitialMethodologies,
                    selected: userMethodologiesUsed
                })
            }
        }
        setMehodologies()
    }, [candidate])
    
    const getGroupNameById = (id) => {
        const group = technologies.find(g => g.id === id);
        return group ? group.name : 'Desconocido';
    };

    useEffect(() => {
        dispatch(getCourseSubjects())
    }, [dispatch])

    useEffect(() => {
        if (candidate) {
            let subjectsArray = []

            if (candidate?.idealPositions?.teacher?.practice?.active) {
                for (const subject of candidate?.idealPositions?.teacher?.practice?.subjects) {
                    if (!subjectsArray.includes(parseInt(subject))) {
                        subjectsArray.push(parseInt(subject))
                    }
                }
            }

            if (candidate?.idealPositions?.teacher?.substitution?.active) {
                for (const subject of candidate?.idealPositions?.teacher?.substitution?.subjects) {
                    if (!subjectsArray.includes(parseInt(subject))) {
                        subjectsArray.push(parseInt(subject))
                    }
                }
            }

            if (candidate?.idealPositions?.teacher?.work?.active) {
                for (const subject of candidate?.idealPositions?.teacher?.work?.subjects) {
                    if (!subjectsArray.includes(parseInt(subject))) {
                        subjectsArray.push(parseInt(subject))
                    }
                }
            }

            setUsedSubjects(subjectsArray)
        }
    }, [candidate])

    const handleReportModalClose = () => setShowReportModal(false)
    const handleReportModalShow = (toReport) => {
        setShowReportModal(true);
        setCandidateReport(toReport);
    }

    const handleReportSubmit = async () => {
        dispatch(reportCandidate(candidateReport, {school: client?.id, additionalComments, selectedOptions}))
    }

    useEffect(() => {
        if (resultcandidate) {
            switch (resultcandidate) {
                case 'successreported':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('report.successreported')
                    })
                    break
                default:
                    break
            }
        }
        // eslint-disable-next-line
    }, [resultcandidate])

    return (
        <>
            <Container>
                <Card className='candidate'>
                    <Card.Body>
                        <Row className="mb-5">
                            <Col xs={12} className='d-flex align-items-center justify-content-between'>
                                <div className='d-flex justify-content-start align-items-center'>
                                    <div>
                                        <div className='avatar me-4'>
                                            <div className='img-profile' style={{backgroundImage: `url(${selectedCandidate?.user?.image ? selectedCandidate?.user.image : "/images/avatar-empty.svg"})`}}/>
                                             {
                                                (selectedCandidate?.currentSelections && selectedCandidate?.currentSelections > 0 ? true : false) &&
                                                    <Badge bg='danger' className='number-info' title={t('candidate.numberSelection')}>{selectedCandidate.currentSelections}</Badge>
                                            }
                                        </div>
                                    </div>
                                    <div className='name'>
                                        <h1>{candidate?.firstname} {candidate?.lastname} {candidate?.linkedin && candidate?.linkedin.includes("http") ? <><a href={candidate?.linkedin} target="_blank"><i className='fab fa-linkedin'></i></a></> : <></>}</h1>
                                        <p className='mb-0'>{candidate?.town ? towns.find(t => t.value === candidate?.town)?.label : ''} {candidate?.province ? `(${provinces.find(p => p.value === candidate?.province)?.label})` : ''}</p>
                                        {candidate?.academic?.length > 0
                                            ?
                                                candidate?.academic?.map((title, key) => (
                                                    <small key={key} >
                                                        {key > 0 ? (key === candidate?.academic?.length - 1 ? ` ${t('global.and')} ` : ', ') : ''}
                                                        {title.type === 'title'
                                                            ?
                                                                t('titles.' +titles?.find(t => t.id === parseInt(title.title))?.title) || t('profile.candidate.' + title.type) + ' - ' + t('titles.' + title.title)
                                                            :
                                                                <>
                                                                    {t('profile.candidate.'+title.type)}: {title.title}
                                                                </>
                                                        }

                                                    </small>
                                                ))
                                            :
                                                <></>
                                        }
                                        {client?.rol === 'Superadmin'
                                            ?
                                                <>
                                                    <div>{candidate?.phone}</div>
                                                    <div>{candidateuser?.email}</div>
                                                </>
                                            : <></>
                                        }
                                    </div>
                                </div>
                                {
                                    (affinity || actions != {})
                                    ?
                                        <div className='d-flex actions me-5'>
                                            {
                                                affinity !== null &&
                                                <Badge className={`porcentaje ${affinity > 85 ? 'bg-high' : (affinity >= 60 ? 'bg-medium' : 'bg-low')}`}>
                                                    {affinity}%
                                                </Badge>
                                            }
                                            {
                                                actions != {} &&
                                                <div className={`d-flex ${affinity !== null ? 'ms-2 ps-2 border-start' : ''}`}>
                                                    {
                                                        actions.favourite
                                                        ?
                                                            favourite
                                                            ?
                                                                <img src='/images/favourite.svg' alt='Favorito' className='normal-with-hover cursor' onClick={() => actions.favourite(selectedCandidate?.candidate, 'removeFavourite')} />
                                                            :
                                                                <img src='/images/favourite.svg' alt='Favorito' className='grey-with-hover cursor' onClick={() => actions.favourite(selectedCandidate?.candidate, 'addFavourite')} />
                                                        :
                                                            <></>
                                                    }
                                                    {
                                                        actions.block
                                                        ?
                                                            <img src='/images/block.svg' alt='Favorito' className={`grey-with-hover cursor ${actions.favourite ? 'ms-2' : ''}`} onClick={() => {actions.block(selectedCandidate?.candidate, 'addBlocked')}} />
                                                        :
                                                            <></>
                                                    }
                                                    <img
                                                        src='/images/message-report.svg' alt='Añadir'
                                                        className={`cursor ${actions.favourite || actions.block ? 'ms-2' : ''}`} 
                                                        onClick={() => handleReportModalShow(candidateToShow?.iduser)}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    :
                                        <></>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={9}>
                                {/* Carta de presentación */}
                                <Accordion flush className='mb-5'>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header className='profile-accordion'>
                                            <h3 className='border-0'>{t('users.cover_letter')}</h3>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(candidate?.cover_letter)}} />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                {/* Experiencia laboral */}
                                <Accordion flush className='mb-5'>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header className='profile-accordion'>
                                            <h3 className='border-0'>{t('profile.candidate.professional')}</h3>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            {
                                                candidate?.professional?.length > 0
                                                    ?
                                                        <div>
                                                            {candidate?.professional?.map((work, key) => (
                                                                <Col xs={12} className='bloque-profesional' key={key}>
                                                                    <div className='d-flex justify-content-between align-items-center'>
                                                                        <div className='fecha'>
                                                                            {work.start_date ? work.start_date?.substr(8,2)+'/'+work.start_date?.substr(5,2)+'/'+work.start_date?.substr(0,4) : t('profile.candidate.nodate')}
                                                                            &nbsp;-&nbsp;
                                                                            {work.end_date ? work.end_date?.substr(8,2)+'/'+work.end_date?.substr(5,2)+'/'+work.end_date?.substr(0,4) : work.start_date ? t('profile.candidate.upToday') : t('profile.candidate.nodate')}
                                                                        </div>
                                                                        {work.contractType &&
                                                                            <div className='tipocontrato'>
                                                                                {t('profile.candidate.'+work.contractType)}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            <h5>{work.work}</h5>
                                                                            <div><strong>{work.companyName}</strong> | {work.town}</div>
                                                                            {
                                                                            work.taughtSubjects.length > 0
                                                                            ?
                                                                            <>
                                                                                <h6 className='mt-3'>{t('profile.candidate.taughtSubjects')}</h6>
                                                                                <ul>
                                                                                { work.taughtSubjects.map((subject, key) => (
                                                                                    <li key={key}>
                                                                                        <small>
                                                                                            {t('profile.candidate.subjects.'+subject)}
                                                                                        </small>
                                                                                    </li>
                                                                                ))}
                                                                                </ul>
                                                                            </>
                                                                            :
                                                                            <></>
                                                                            }
                                                                            <small>{work.description}</small>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            ))}
                                                        </div>
                                                    :
                                                        <></>
                                            }
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                {/* Perfil académico */}
                                <Accordion flush className='mb-5'>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header className='profile-accordion'>
                                            <h3 className='border-0'>{t('profile.candidate.academic')}</h3>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            {
                                                candidate?.academic?.length > 0
                                                ?
                                                    candidate?.academic?.map((title, key) => (
                                                        <Col xs={12} className='bloque-adjuntos d-flex justify-content-between align-items-center' key={key}>
                                                            <div className='d-flex'>
                                                                <div>
                                                                    <h4 className='fw-bold'>
                                                                    {title.type === 'title'
                                                                        ?
                                                                            t('titles.' +titles?.find(t => t.id === parseInt(title.title))?.title) || t('profile.candidate.' + title.type) + ' - ' + t('titles.' + title.title)
                                                                        :
                                                                            <>
                                                                                {t('profile.candidate.'+title.type)}: {title.title}
                                                                            </>
                                                                    }

                                                                    </h4>
                                                                    {title.studyCentre} | {title.end_date ? title.end_date?.substr(5,2)+' - '+title.end_date?.substr(0,4) : t('profile.candidate.nodate')}
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <a href={title.certificationUrl} download target="_blank" rel="noreferrer">
                                                                    <i className='fas fa-download'/>
                                                                </a>
                                                            </div>
                                                        </Col>
                                                    ))
                                                :
                                                    <></>
                                            }
                                            {
                                                candidate?.courses?.length > 0
                                                ?
                                                    candidate?.courses?.map((title, key) => (
                                                        <Col xs={12} className='bloque-adjuntos d-flex justify-content-between align-items-center' key={key}>
                                                            <div className='d-flex'>
                                                                <div>
                                                                    <h4 className='fw-bold'>{t('profile.candidate.course')}: {title.name}</h4>
                                                                    {title.studyCentre} | {title.duration}h
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <a href={title.diplomaUrl} download target="_blank" rel="noreferrer">
                                                                    <i className='fas fa-download'/>
                                                                </a>
                                                            </div>
                                                        </Col>
                                                    ))
                                                :
                                                    <></>
                                            }
                                            {
                                                candidate?.teacherFormationMaster &&
                                                    <Col xs={12} className='bloque-adjuntos d-flex justify-content-between align-items-center'>
                                                        <div className='d-flex'>
                                                            <div>
                                                                <h4 className='fw-bold'>{t('profile.candidate.teacherFormationMaster')}</h4>
                                                                {candidate.teacherFormationMaster.studyCentre} | {candidate.teacherFormationMaster.end_date ? candidate.teacherFormationMaster.end_date?.substr(5,2) + ' - ' + candidate.teacherFormationMaster.end_date?.substr(0,4) : t('profile.candidate.nodate')}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <a href={candidate.teacherFormationMaster.certificationUrl} download target="_blank" rel="noreferrer">
                                                                <i className='fas fa-download'/>
                                                            </a>
                                                        </div>
                                                    </Col>
                                            }
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                {/* CV y carta de recommendación */}
                                <Accordion flush className='mb-5'>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header className='profile-accordion'>
                                            <h3 className='border-0'>{t('profile.candidate.curriculum')} & {t('profile.candidate.recommendation')}</h3>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            {
                                                candidate?.curriculumUrl &&
                                                    <Col xs={12} className='bloque-adjuntos d-flex justify-content-between align-items-center'>
                                                        <div className='d-flex'>
                                                            <div>
                                                                <h4 className='fw-bold'>{t('profile.candidate.curriculum')}</h4>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <a href={candidate.curriculumUrl} download target="_blank" rel="noreferrer">
                                                                <i className='fas fa-download'/>
                                                            </a>
                                                        </div>
                                                    </Col>
                                            }
                                            {
                                                candidate?.recommendationLetterUrl &&
                                                    <Col xs={12} className='bloque-adjuntos d-flex justify-content-between align-items-center'>
                                                        <div className='d-flex'>
                                                            <div>
                                                                <h4 className='fw-bold'>{t('profile.candidate.recommendation')}</h4>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <a href={candidate.recommendationLetterUrl} download target="_blank" rel="noreferrer">
                                                                <i className='fas fa-download'/>
                                                            </a>
                                                        </div>
                                                    </Col>
                                            }
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                {/* Historial de procesos */}
                                <Accordion flush className='mb-5'>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header className='profile-accordion'>
                                            <h3 className='border-0'>{t('selection.processHistory', {total: history.length || 0})}</h3>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            {
                                                historyLoading
                                                    ?
                                                        <span className="spinner-border spinner-border-sm align-middle ms-2"/>
                                                    :
                                                    (history ||[])?.map((h, i) => (
                                                        <div className='mb-3 row align-items-center p-3 pair-colored' key={i}>
                                                            <Col xs={6} className='pe-4 border-end'>
                                                                <h4 className='fw-bold border-0 mb-2 p-0'>{h.selection.title}</h4>
                                                                <div className='color-primary'>{new Date(h.selection.startDate).toLocaleDateString()}</div>
                                                            </Col>
                                                            <Col xs={6} className='ps-4'>
                                                                <ul>
                                                                    <li className='mb-3'>
                                                                        <strong>{t("selection.stage")}:</strong> {t("selection.stages."+ (h.step || 'noStage'))}
                                                                    </li>
                                                                    <li className='mb-3'>
                                                                        {
                                                                            h.message
                                                                            ?
                                                                                <Accordion>
                                                                                    <div>
                                                                                        <strong>{t("selection.reason")}:</strong> {t("selection.dimiss."+ (h.dimissReason || 'noReason'))}
                                                                                        <DimissMessageToggle eventKey='0'/>
                                                                                    </div>
                                                                                    <Accordion.Collapse eventKey='0'>
                                                                                        <div className='mt-2 pt-2 border-top' dangerouslySetInnerHTML={{__html: h.message.replace("\n", '<br>')}}></div>
                                                                                    </Accordion.Collapse>
                                                                                </Accordion>
                                                                            :
                                                                                <>
                                                                                    <strong>{t("selection.reason")}:</strong> {t("selection.dimiss."+ (h.dimissReason || 'noReason'))}
                                                                                </>
                                                                        }
                                                                    </li>
                                                                </ul>
                                                            </Col>
                                                        </div>
                                                    ))
                                            }
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Col>
                            <Col xs={3}>
                                <Card className='columnaIzquierda'>
                                    <Card.Body className='p-5'>
                                        {/* ASIGNATURAS */}
                                        {
                                            candidate?.idealPositions?.teacher?.practice?.active || candidate?.idealPositions?.teacher?.substitution?.active || candidate?.idealPositions?.teacher?.work?.active
                                            ?
                                                <>
                                                    <h5>{t('profile.candidate.idealPosition.subjects')}</h5>
                                                    <div className='d-flex flex-wrap mb-3'>
                                                        {usedSubjects?.map((language, key) => (
                                                            <div className='pildora' key={key}>
                                                                {t("subjects." + subjects.find(s => s.id === language)?.label)}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </>
                                            :
                                                <></>
                                        }
                                        {/* VALORES */}
                                        {
                                            candidate?.languages?.length > 0
                                            ?
                                            <>
                                                <h5>{t('profile.candidate.languages')}</h5>
                                                <div className='d-flex flex-wrap'>
                                                    {candidate?.languages?.map((language, key) => (
                                                        <div className='pildora' key={key}>
                                                            {language.language} - {language.level}
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }

                                        {/* VALORES */}
                                        {
                                            candidate?.values?.length > 0
                                            ?
                                            <>
                                                <h5 className='mt-3'>{t('profile.candidate.values')}</h5>
                                                <div className='d-flex flex-wrap'>
                                                    {candidate?.values?.sort((a, b) => {
                                                        if (a.label < b.label) {
                                                            return -1
                                                        }
                                                        if (a.label > b.label) {
                                                            return 1
                                                        }
                                                        return 0
                                                    })?.map((value, key) => (
                                                        <div className='pildora' key={key}>
                                                            {t('values.'+value)}
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }
                                        {/* COMPETENCIAS */}
                                         {
                                            competencesSelected?.selected?.length > 0
                                            ?
                                            <>
                                                <h5 className='mt-3'>{t('profile.candidate.competences')}</h5>
                                                <div className='d-flex flex-wrap'>
                                                    {competencesSelected?.selected?.map((competence, key) => (
                                                        <div className='pildora' key={key}>
                                                            {competence.name}
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }
                                        {/* TECNOLOGÍAS */}
                                        <h5 className='mt-3'>{t('profile.candidate.technologies')}</h5>
                                        {
                                        candidate?.technologies?.technologyGroups?.map((group) => (
                                                    <div key={group.id}>
                                                        <small>{getGroupNameById(group.id)}</small>
                                                        {
                                                            <div className='d-flex flex-wrap'>
                                                            {
                                                            group.technologies.map((technology) => (
                                                                <div className='pildora' key={technology}>
                                                                    {technology.includes('others:')
                                                                    ?
                                                                        technology.replace('others:', t('users.other')+': ')
                                                                    :
                                                                        technology
                                                                    }

                                                                </div>
                                                            ))
                                                            }
                                                            </div>
                                                        }
                                                    </div>
                                                ))
                                        }
                                        {/* OFFICE  */}
                                        <small>{t('profile.candidate.officeLevel.title')}</small>
                                        {
                                            candidate?.technologies?.officeLevel?.length > 0
                                            ?
                                                <div className='pildora'>
                                                {t('profile.candidate.officeLevel.'+candidate?.technologies?.officeLevel)}
                                                </div>
                                            :
                                            <></>
                                        }
                                        {/* ECOSISTEMAS */}
                                        {
                                            candidate?.technologies?.noEcosystems || candidate?.technologies?.noEcosystems === 'undefined'
                                            ?
                                            <></>
                                            :
                                            <>
                                                <small>{t('profile.candidate.ecosystems.title')}</small>
                                                <div className='d-flex flex-wrap'>
                                                    {candidate?.technologies?.ecosystems?.map((ecosystem, key) => (
                                                        <div className='pildora' key={key}>
                                                            {ecosystem}
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                        }
                                        {/* SOFTWARES */}
                                        {
                                            candidate?.technologies?.noSoftwares
                                            ?
                                            <></>
                                            :
                                            <>
                                                <small>{t('profile.candidate.educationalSoftwareTitle')}</small>
                                                <div className='d-flex flex-wrap'>
                                                    {candidate?.technologies?.softwares?.map((software, key) => (
                                                        <div className='pildora' key={key}>
                                                            {software}
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                        }
                                        {/* METODOLOGÍAS */}
                                        {
                                            methodologiesSelected?.selected?.length > 0
                                            ?
                                            <>
                                                <h5 className='mt-3'>{t('profile.candidate.methodologies')}</h5>
                                                <div className='d-flex flex-wrap'>
                                                    {methodologiesSelected?.selected?.map((methodologie, key) => (
                                                        <div className='pildora' key={key}>
                                                            {methodologie.name}
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Container>
            <Modal show={showReportModal} onHide={handleReportModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t('report.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="reportReason">
                            <Form.Label>{t('report.reason')}</Form.Label>
                            {['accreditations', 'homologation', 'personaldata', 'inappropriatelanguage', 'inappropriatephoto', 'notrespond', 'inappropriatephotoaccreditations', 'others'].map((option, index) => (
                                <Form.Check
                                    id={`checkbox-${option}`}
                                    type="checkbox"
                                    label={t(`report.${option}`)}
                                    key={index}
                                    checked={selectedOptions?.includes(option)}
                                    onChange={(e) => handleCheckChange(e, option)}
                                />
                            ))}
                        </Form.Group>
                        <Form.Group controlId="additionalComments" className="mt-3">
                            <Form.Label>{t('report.additionalComments')}</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                onChange={(e) => setAdditionalComments(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleReportModalClose}>
                        {t('global.cancel')}
                    </Button>
                    <Button variant="primary" onClick={handleReportSubmit}>
                        {t('report.sendreport')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

function DimissMessageToggle ({eventKey, callback}) {
    const decoratedOnClick = useAccordionButton(
        eventKey,
        () => callback && callback(eventKey),
    );
    return (
        <i className='fas fa-eye cursor ms-2' onClick={decoratedOnClick}/>
    )
}